import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { AnswerSection } from './AnswerSection';
import { TopicSection } from './TopicsSection';
import { getCurrentQuestion } from '../../../selectors/HelpTopicsSelectors';

const useStyles = makeStyles({
  answerSectionContainer: {
    height: 420,
    justifyContent: 'center',
  },
});

export const AnswerPanel = () => {
  const classes = useStyles();

  const [topicIndex, setTopicIndex] = useState(0);
  const [page, setPage] = useState(0);

  const { answerInfo } = useSelector(getCurrentQuestion);

  const props = {
    topicIndex,
    setTopicIndex,
    setPage,
    answerInfo,
    page,
  };

  return (
    <Grid spacing={2} container className={classes.answerSectionContainer}>
      <Grid item sm={5}>
        <TopicSection {...props} />
      </Grid>
      <Grid item sm={7}>
        <AnswerSection {...props} />
      </Grid>
    </Grid>
  );
};
